import React from 'react';
import { Outlet } from 'react-router-dom';

import AppHeader from 'components/Layouts/Header';
import AppFooter from 'components/Layouts/Footer';
import style from './style.module.scss';

const AppLayout: React.FC = () => {
  return (
    <div className={style.layout}>
      <AppHeader />
      <Outlet />
      <AppFooter />
    </div>
  );
};

export default AppLayout;
